export default {
  hex(color, defaultColor) {
    if (defaultColor === undefined) {
      defaultColor = '#444444'
    }
    if(color.hex === undefined) {
      color = Core.Value.encode(color, 'color')
    }
    if (color.hex !== undefined) {
      return color.hex
    }
    return defaultColor
  },
  rgba(color) {
    if (color.rgba !== undefined) {
      color = 'rgb(' +  color.rgba.r + ',' +  color.rgba.g + ',' + color.rgba.b + ',' +  color.rgba.a + ')'
    } else {
      return ''
    }
    return color
  }
}
